import { APICore } from './apiCore'

const api = new APICore()

function getRedes (params) {
  const baseUrl = '/redes'
  return api.get(baseUrl, params)
}

function getRed (id) {
  const baseUrl = `/redes/${id}`
  return api.get(baseUrl, {})
}

function addRed (params) {
  const baseUrl = '/redes'
  return api.createWithFile(baseUrl, params)
}

function updateRed (params) {
  const baseUrl = '/redes'
  return api.updateWithFile(baseUrl, params)
}

function deleteRed (params) {
  const baseUrl = '/redes'
  return api.delete(baseUrl, params)
}

export { getRedes, getRed, addRed, updateRed, deleteRed }
